<script setup lang="ts">
import { ref } from 'vue'
import DashboardNavIcon from '@/components/dashboard/shell/DashboardNavIcon.vue'

type MatchingAccordionIcon =
  | 'settings'
  | 'email'
  | 'card'
  | 'history'

const props = withDefaults(
  defineProps<{
    panelId: string
    title: string
    icon: MatchingAccordionIcon
    summary?: string
    defaultOpen?: boolean
  }>(),
  {
    summary: '',
    defaultOpen: false,
  }
)

const isOpen = ref(props.defaultOpen)

const toggle = () => {
  isOpen.value = !isOpen.value
}
</script>

<template>
  <div
    class="sa-matching-accordion-panel"
    :class="{ 'sa-matching-accordion-panel--open': isOpen }"
  >
    <button
      type="button"
      class="sa-matching-accordion-panel__trigger"
      :aria-expanded="isOpen"
      :aria-controls="panelId"
      @click="toggle"
    >
      <span class="sa-matching-accordion-panel__heading">
        <span class="sa-matching-accordion-panel__icon" aria-hidden="true">
          <DashboardNavIcon :name="icon" />
        </span>
        <span class="sa-matching-accordion-panel__title">{{ title }}</span>
      </span>
      <span class="sa-matching-accordion-panel__end">
        <span
          v-if="summary && !isOpen"
          class="sa-matching-accordion-panel__summary"
        >
          {{ summary }}
        </span>
        <svg
          class="sa-matching-accordion-panel__chevron"
          viewBox="0 0 20 20"
          fill="currentColor"
          aria-hidden="true"
        >
          <path
            fill-rule="evenodd"
            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
            clip-rule="evenodd"
          />
        </svg>
      </span>
    </button>

    <div v-show="isOpen" :id="panelId" class="sa-matching-accordion-panel__body">
      <slot />
    </div>
  </div>
</template>
